module.exports = __webpack_public_path__ + "img/circle.78678721.svg";